module.exports = {
  ruleServerUrl: 'https://api.casa.ample.co.in',
  turnedOffFeatures: ['journey-builder', 'flipbook-image-tagger']
};
